import { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function useTextProcessorConfamaDematology() {
  const [dataTextProcessor, setDataTextProcessor] = useState();
  const [loadingTextProcessor, setLoadingTextProcessor] = useState(false);
  const [errorTextProcessor, setErrorTextProcessor] = useState();
  const {
    t,
    i18n: { language },
  } = useTranslation("global");

  const urlEndpointTextProcessor =
    "https://monaco-dermatology-back-54644131242.us-central1.run.app/chat-medico";

  const textProcessor = async (msg, context, patientId, doctorId, threadId) => {
    try {
      setLoadingTextProcessor(true);
      const promptFinal = context
        ? `[CONTEXTO]: ${context}\n\n[PREGUNTA]: ${msg}`
        : msg;

      const payloadMastra = {
        messages: [{ role: "user", content: promptFinal }],
        threadId: threadId,
        resourceId: patientId,
        metadata: { doctorid: doctorId, variablesatisfaccion: 0 },
      };

      const response = await axios.post(
        urlEndpointTextProcessor.toString(),
        payloadMastra,
      );

      setDataTextProcessor(response);
      return response;
    } catch (error) {
      setErrorTextProcessor(error);
    } finally {
      setLoadingTextProcessor(false);
    }
  };

  const cleanActionTextProcessor = () => {
    setDataTextProcessor(null);
    setLoadingTextProcessor(false);
    setErrorTextProcessor(null);
  };

  return {
    textProcessor,
    dataTextProcessor,
    loadingTextProcessor,
    errorTextProcessor,
    cleanActionTextProcessor,
  };
}
